module.exports = __webpack_public_path__ + "static/img/open3.5e99bb6c.png";